// `navigator.clipboard` is absent on insecure origins, so the optional call keeps callers from
// throwing synchronously past their `.catch`.
export const copyToClipboard = (text: string): Promise<void> =>
    navigator.clipboard?.writeText(text) ?? Promise.resolve()

/**
 * WebKit-safe copy for text that is only known after an async request: the `ClipboardItem` gets the
 * *promise* of the blob, so the write stays attached to the originating user gesture. Not supported
 * by older Firefox — https://bugs.webkit.org/show_bug.cgi?id=222262.
 */
export const copyToClipboardAsync = <T>(
    requestFn: () => Promise<T>,
    transformFn: (data: T) => string,
) =>
    navigator.clipboard.write([
        new ClipboardItem({
            'text/plain': requestFn().then(
                data => new Blob([transformFn(data)], { type: 'text/plain' }),
            ),
        }),
    ])
